package one.healthium.domain.common


import kotlinx.serialization.Contextual
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@Serializable
data class Animations(
    @SerialName("shimmering") val shimmering: Shimmering? = null,
)


@Serializable
data class Shimmering(
    @SerialName("kind") val kind: String,
    @SerialName("color") @Contextual val color: Color,
    @SerialName("duration") val duration: Int,
    @SerialName("interval") val interval: Int,
)